import 'core-js/stable'
import 'regenerator-runtime/runtime'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App.js'
import '@fontsource/lato'
import CustomThemeProvider from './CustomThemeProvider'
import { BrowserRouter } from 'react-router-dom'
import LanguageWrapper from './components/LanguageWrapper'
import UnsupportedBrowser from './components/UnsupportedBrowser'

const isIE = window.navigator.userAgent.match(/(MSIE|Trident)/)

ReactDOM.render(
  <CustomThemeProvider>
    <BrowserRouter>
      <LanguageWrapper>{isIE ? <UnsupportedBrowser /> : <App />}</LanguageWrapper>
    </BrowserRouter>
  </CustomThemeProvider>,
  document.getElementById('root'),
)

// Hot Module Replacement (HMR) - Remove this snippet to remove HMR.
// Learn more: https://www.snowpack.dev/concepts/hot-module-replacement
if (import.meta.hot) {
  import.meta.hot.accept()
}
